import { createNavigation } from 'next-intl/navigation';
import { defineRouting } from 'next-intl/routing';

export const locales = ['en', 'kz', 'ru'] as const;

export const routing = defineRouting({
    locales: ['en', 'kz', 'ru'],
    defaultLocale: 'ru',
});

export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing);
